<!-- TODO: this component needs to be refactored - split on several child components based on viewMode -->
<!-- TODO: <div class="card-body" ...> section needs to be separated in it's own component as well -->
@if (viewMode == "default" && !isStoryMode) {
  <div #galleryContainer></div>
  <div
    class="post-card"
    #card
    [class.has-custom-bg]="!!backgroundColor"
    [style.--post-bg]="backgroundColor || null"
    [style.--post-fg]="foregroundColor"
    [ngClass]="{
      selected: post.selected,
      highlighted: highlighted,
      parent: post.is_parent,
      collapsed: post.is_collapsed,
    }"
  >
    <!-- Context label: shown on parent posts in threads mode -->
    @if (showThreads && post.is_parent) {
      <div class="thread-context-label">
        <fa-icon [icon]="['fas', 'quote-left']"></fa-icon>
        <span>{{ "post-card.label.thread-context" | translate }}</span>
      </div>
    }
    <!-- Reply indicator: shown on child posts in threads mode -->
    @if (showThreads && post.has_parent_thread && !post.is_parent) {
      <div class="thread-reply-indicator">
        <fa-icon [icon]="['fas', 'reply']"></fa-icon>
        <span>{{ "post-card.label.matched-reply" | translate }}</span>
      </div>
    }
    <div class="card-header">
      <div class="card-info">
        @if (isSelectable) {
          <div class="select-tool" (click)="togglePostSelect()">
            <sui-checkbox [checked]="post.selected"></sui-checkbox>
          </div>
        }
        @if (post.icon) {
          <div class="post-type">
            <fa-icon [icon]="post.icon"></fa-icon>
          </div>
        }
        <!-- Take sentiment_id from the first element in post_sentiment_algorithm_list and use it as div class for sentiment
        sentiment_id 1 is neutral, 2 is positive, 3 is negative
        for text, use the "title" from the first element in post_sentiment_algorithm_list -->
        @if (
          postToolsConfig["sentiment"] && post.post_sentiment_algorithm_list[0];
          as sentiment
        ) {
          <div [class.disabled]="disableTools">
            <div
              [suiMenuTrigger]="sentimentMenu1"
              [suiMenuTriggerDisabled]="isShadow"
              class="sentiment {{
                sentimentClassMap[
                  post.post_sentiment_algorithm_list[0].sentiment_id
                ] ?? 'neutral'
              }}"
            >
              {{ post.post_sentiment_algorithm_list[0].title }}
              @if (
                userFacade.hasPermissionSync(
                  AppComponents.FEED_SEARCH_RESULTS_DISPLAY_SENTIMENT_IS_MODIFIED
                ) &&
                sentiment.is_default &&
                post.sentiment_value_original.id
              ) {
                <div
                  class="sentiment-tag-changed"
                  [class.neutral]="
                    post.sentiment_value_original.id == NomSentiment.NEUTRAL
                  "
                  [class.positive]="
                    post.sentiment_value_original.id == NomSentiment.POSITIVE
                  "
                  [class.negative]="
                    post.sentiment_value_original.id == NomSentiment.NEGATIVE
                  "
                  [suiTooltip]="post.sentiment_value_original.text"
                >
                  <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
                </div>
              }
            </div>
            <ng-template #sentimentMenu1>
              <sui-menu>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.NEGATIVE)"
                >
                  <fa-icon [icon]="['fas', 'face-frown']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.negative" | translate
                  }}</span>
                </button>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.NEUTRAL)"
                >
                  <fa-icon [icon]="['fas', 'face-meh']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.neutral" | translate
                  }}</span>
                </button>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.POSITIVE)"
                >
                  <fa-icon [icon]="['fas', 'smile']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.positive" | translate
                  }}</span>
                </button>
              </sui-menu>
            </ng-template>
          </div>
        }
        @if (postToolsConfig["post_time_published_relative"]) {
          <div class="post-date">
            {{ post.publish_time.relative }}
          </div>
        }
        @if (postToolsConfig["post_time_published_absolute"]) {
          <div class="post-date">
            {{ post.publish_time.absolute | date: "dd.MM.yyyy HH:mm" }}
          </div>
        }
        @if (postToolsConfig["post_time_created_relative"]) {
          <div class="post-date">
            {{ post.created_time.relative }}
          </div>
        }
        @if (postToolsConfig["post_time_created_absolute"]) {
          <div class="post-date">
            {{ post.created_time.absolute | date: "dd.MM.yyyy HH:mm" }}
          </div>
        }
        <a [href]="post.url" target="_blank">
          <fa-icon [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
        </a>
        @if (user?.access_level_id >= UserAccessLevel.GLOBAL_ADMIN) {
          <div
            class="completeness-score"
            [class.low]="post.completeness_score <= 25"
            [class.medium]="
              post.completeness_score > 25 && post.completeness_score <= 75
            "
            [class.high]="post.completeness_score > 75"
          >
            <fa-icon [icon]="scoreIcon"></fa-icon>
            <span>{{ post.completeness_score }}</span>
          </div>
        }
        @if (
          post.has_synopsis &&
          userFacade.hasPermissionSync(
            AppComponents.POST_DETAILS_PANE_SYNOPSIS_EDITOR
          )
        ) {
          <div
            class="has-synopsis"
            [suiTooltip]="'post-card.tooltip.has-synopsis' | translate"
          >
            <fa-icon [icon]="['fas', 'clipboard-list']"></fa-icon>
          </div>
        }
        @if (post.has_transcription) {
          <div
            class="has-trancription"
            [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
          >
            <fa-icon [icon]="['fas', 'message']"></fa-icon>
          </div>
        }
        @if (post.has_translation) {
          <div
            class="has-translation"
            [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
          >
            <fa-icon [icon]="['fas', 'language']"></fa-icon>
          </div>
        }
        @if (hasScreenCapture) {
          <div
            class="has-screen-capture"
            [suiTooltip]="'post-card.tooltip.has-screen-capture' | translate"
          >
            <fa-icon [icon]="['fas', 'camera']"></fa-icon>
          </div>
        }
      </div>
      <div class="card-tools">
        @if (!disableTools && postToolsConfig["view-details"]) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.view-details' | translate"
              (click)="toggleDetails()"
              ><fa-icon [icon]="['fas', 'eye']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["edit-categories"] && !disableTools && !isShadow) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.edit-categories' | translate"
              (click)="editCategories()"
              ><fa-icon [icon]="['fas', 'tag']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["edit-sentiment"] && !disableTools && !isShadow) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.edit-sentiment' | translate"
              (click)="editSentiment()"
              ><fa-icon [icon]="['far', 'face-smile']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["edit-related"] && !disableTools && !isShadow) {
          <div class="card-tool">
            <a
              [suiTooltip]="
                'post-card.tooltip.link-related-articles' | translate
              "
              (click)="editRelated()"
              ><fa-icon [icon]="['fas', 'chain']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["share"] && !disableTools) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.share' | translate"
              (click)="sharePost()"
              ><fa-icon [icon]="['fas', 'share']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["debug"]) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.debug' | translate"
              target="_blank"
              href="{{ debugUrl }}"
              ><fa-icon [icon]="['fas', 'bug']"></fa-icon
            ></a>
          </div>
        }
        @if (postToolsConfig["translate"] && !disableTools) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.translate' | translate"
              [href]="translateUrl"
              target="_blank"
              ><fa-icon [icon]="['fas', 'language']"></fa-icon
            ></a>
          </div>
        }
        @if (!disableTools && user && !isShadow) {
          <div class="card-tool">
            <sui-button
              size="sm"
              variant="ghost"
              [leadingIcon]="['fas', 'bars']"
              [trailingIcon]="['fas', 'caret-down']"
              [iconOnly]="true"
              ariaLabel="Algorithms"
              [expanded]="postAlgorithmsRef.isOpen()"
              [suiMenuTrigger]="algorithmsMenu1"
              #postAlgorithmsRef="suiMenu"
            ></sui-button>
            <ng-template #algorithmsMenu1>
              <sui-menu>
                @for (item of algorithms; track item; let i = $index) {
                  @if (
                    i > 0 && algorithms[i].group !== algorithms[i - 1].group
                  ) {
                    <sui-menu-separator></sui-menu-separator>
                  }
                  <button sui-menu-item (click)="runAlgorithm(item)">
                    @if (item.icon) {
                      <fa-icon [icon]="item.icon"></fa-icon>
                    }
                    <span>{{ item?.name }}</span>
                  </button>
                }
              </sui-menu>
            </ng-template>
          </div>
        }
        @if (loadingAlgorithmPostIds?.includes(post.id)) {
          <div class="loading-post-algorithm">
            <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
          </div>
        }
        @if (appliedAlgorithmPostIds?.includes(post.id)) {
          <div
            class="applied-post-algorithm"
            [suiTooltip]="'post-card.tooltip.applied-algorithm' | translate"
          >
            <fa-icon [icon]="['fas', 'square-check']"></fa-icon>
          </div>
        }
        @if (
          removable &&
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_REMOVE_CONTENT_FROM_FEED
          ) &&
          !disableTools &&
          !isShadow
        ) {
          <div class="card-tool remove-post">
            <a
              [suiTooltip]="'post-card.tooltip.remove-post' | translate"
              (click)="removeFromFeed()"
              ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
            ></a>
          </div>
        }
        @if (customRemovePost) {
          <div class="card-tool remove-post">
            <a
              [suiTooltip]="'post-card.tooltip.remove-post' | translate"
              (click)="customRemovePost(post); $event.stopPropagation()"
              ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
            ></a>
          </div>
        }
      </div>
    </div>
    <div class="card-body" (click)="togglePostSelect()">
      @if (post.type === "social") {
        <div class="author">
          @if (post.author?.avatar_url) {
            <div class="avatar">
              @if (post.author.profile_url) {
                <a [href]="post.author.profile_url" target="_blank">
                  <img
                    [src]="post.author.avatar_url"
                    [appFallbackImage]="avatarFallback"
                    appLazyLoad
                    class="post-avatar"
                  />
                </a>
              }
              @if (!post.author.profile_url) {
                <img
                  [src]="post.author.avatar_url"
                  [appFallbackImage]="avatarFallback"
                  appLazyLoad
                  class="post-avatar"
                />
              }
            </div>
          }
        </div>
      }
      @if (post.thumbnail && postToolsConfig["thumbnail"]) {
        <a
          [href]="post.type === 'social' ? post.url : null"
          target="_blank"
          (click)="$event.stopPropagation()"
          class="thumbnail"
        >
          <img
            [src]="post.thumbnail"
            appFallbackImage
            [loadingImage]="loadingImage"
            [containerLevelsUp]="1"
            appLazyLoad
            class="post-thumbnail"
          />
        </a>
      }
      <div class="card-content">
        @if (post.type === "social" && post.author; as author) {
          <div class="author-info">
            <!-- Author Name -->
            @if (author.profile_url) {
              <a
                [href]="author.profile_url"
                target="_blank"
                class="author-name"
              >
                {{ author.name }}
              </a>
            }
            @if (!author.profile_url) {
              <span class="author-name">
                {{ author.name }}
              </span>
            }
            <!-- Author Handle -->
            @if (author.username) {
              @if (author.profile_url) {
                <a
                  [href]="author.profile_url"
                  target="_blank"
                  class="author-handle"
                >
                  {{ "@" + author.username }}
                </a>
              }
              @if (!author.profile_url) {
                <span class="author-handle">
                  {{ "@" + author.username }}
                </span>
              }
            }
          </div>
        }
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
        @if (postPropertyConfig["content"]) {
          <a
            [attr.href]="post.type === 'social' ? post.url : null"
            target="_blank"
            (click)="onContentClick($event)"
            class="content"
            [innerHTML]="post.content"
          ></a>
        }
        @if (post.user_categories.length > 0) {
          <div class="user-categories">
            <span class="categories-title">{{
              "post-card.label.categories" | translate
            }}</span>
            @for (
              category of post.user_categories;
              track trackById($index, category)
            ) {
              <span class="user-category" (click)="editCategories()">
                <fa-icon [icon]="['fas', 'tag']"></fa-icon>
                {{ category.name }}</span
              >
            }
          </div>
        }
        @if (
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_EDIT_WORKFLOW
          ) && workflowStages?.length > 0
        ) {
          <div class="workflows">
            <span class="workflows-title">{{
              "post-card.label.workflows" | translate
            }}</span>
            @for (stage of workflowStages; track stage) {
              <div
                class="workflow-stage"
                [ngClass]="{
                  active: stage.is_current,
                  clickable: stage.enabled && !isShadow,
                }"
                (click)="
                  stage.enabled && !isShadow ? changeWorkflowStage(stage) : null
                "
              >
                @if (stage.is_previous) {
                  <fa-icon [icon]="['fas', 'backward-step']"></fa-icon>
                }
                {{ stage.name }}
                @if (stage.is_next) {
                  <fa-icon [icon]="['fas', 'forward-step']"></fa-icon>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (post.attachments?.length > 0) {
      <div class="attachments">
        @for (
          attachment of post.attachments;
          track attachment;
          let i = $index
        ) {
          @if (!(attachment.is_thumbnail && attachment.type == "image")) {
            <div
              class="attachment

        {{ attachment.type }}"
            >
              @switch (attachment.type) {
                <!-- Video Attachment -->
                @case ("video") {
                  <app-video-player
                    [attachment]="attachment"
                    [postId]="post.id"
                    [attachmentId]="post.id + '-' + i"
                    [postTypeId]="post.post_type_id"
                    [contentProviderId]="post.content_provider.id"
                    [autoplay]="false"
                    [class.hide-transcriptions]="
                      !postToolsConfig['transcriptions']
                    "
                  >
                  </app-video-player>
                }
                <!-- Image Attachment -->
                @case ("image") {
                  <img
                    [src]="attachment.image_src"
                    appFallbackImage
                    [containerLevelsUp]="1"
                    (click)="openGallery()"
                  />
                  <!--
                    <a *ngIf="attachment.downloadable" [href]="attachment.href" download>Download</a>
                    -->
                }
                <!-- Article Attachment -->
                @case ("article") {
                  <div class="article-attachment">
                    <a
                      [href]="$safeNavigationMigration(attachment?.link)"
                      target="_blank"
                      >{{ attachment?.title }}</a
                    >
                    <span class="descritpion">
                      {{ attachment?.description }}
                    </span>
                  </div>
                }
              }
            </div>
          }
        }
      </div>
    }
    <div class="card-footer">
      <div class="source">
        <a [href]="post.source.url" target="_blank">
          <img
            [src]="post.source.icon_url"
            appFallbackImage
            [loadingImage]="loadingImage"
            appLazyLoad
          />
          <span class="source-title" [suiTooltip]="post.source.title">{{
            sourceTitle
          }}</span>
        </a>
        @if (
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_REMOVE_SOURCE_FROM_FEED
          ) &&
          !disableTools &&
          !isShadow
        ) {
          <fa-icon
            [icon]="['fas', 'ban']"
            (click)="removeSourcePosts(post.source)"
            [suiTooltip]="
              'post-card.tooltip.remove-posts-from-this-source' | translate
            "
          ></fa-icon>
        }
        @if (
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_DEBUG_SOURCE
          )
        ) {
          <a href="{{ debugSourceUrl }}" target="_blank"
            ><fa-icon [icon]="['fas', 'bug']"></fa-icon
          ></a>
        }
      </div>
      <div class="properties">
        @for (postProperty of postPropertyViewConfig; track postProperty) {
          <div class="property">
            <div class="name">{{ postProperty.label }}</div>
            <div class="value" [title]="postProperty.value">
              <fa-icon [icon]="postProperty.icon"></fa-icon>
              {{ postProperty.value | humanizeNumber: 1 }}
            </div>
          </div>
        }
      </div>
      @if (
        userFacade.hasPermissionSync(
          AppComponents.FEED_SEARCH_RESULTS_SET_CATEGORIES
        ) && feed?.company_categories.length > 0
      ) {
        <div class="feed-categories-holder" #postCategoryTree>
          <div
            (click)="toggleCategoryTree($event)"
            class="category-tree-toggle"
          >
            <span>{{ companyCategoryNames }}</span>
            @if (!categoryTreeVisible && !isShadow) {
              <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
            }
            @if (categoryTreeVisible) {
              <fa-icon [icon]="['fas', 'chevron-up']"></fa-icon>
            }
          </div>
          @if (categoryTreeVisible) {
            <app-post-category-tree
              [selectedCategories]="
                $safeNavigationMigration(post?.user_categories)
              "
              [postId]="post.id"
              (requestClose)="categoryTreeVisible = false"
            ></app-post-category-tree>
          }
        </div>
      }
    </div>
    @if (
      allowRelatedPosts &&
      (post.post_parent_related_count > 0 || post.post_child_related_count > 0)
    ) {
      <div
        class="card-footer-tools"
        [ngClass]="{ parent: post.post_child_related_count > 0 }"
      >
        <i class="mdi mdi-link"></i>
        @if (post.post_child_related_count > 0) {
          <span>
            {{
              "post-card.footer.message.this-article-is-parent-of-count-related-articles"
                | translate: { related_count: post.post_child_related_count }
            }}
          </span>
        }
        @if (
          post.post_parent_related_count > 0 &&
          post.post_child_related_count === 0
        ) {
          <span>
            {{
              "post-card.footer.message.this-article-is-related-to-another-article"
                | translate
            }}
          </span>
        }
        <span class="edit-related" (click)="editRelated()">{{
          "post-card.footer.show-more" | translate
        }}</span>
      </div>
    }
  </div>
}

@if (viewMode == "gallery") {
  <div class="post-card gallery" [ngClass]="{ selected: post.selected }">
    @if (!disableTools) {
      <div class="card-header">
        <div class="card-info">
          @if (isSelectable) {
            <div class="select-tool" (click)="togglePostSelect()">
              <sui-checkbox [checked]="post.selected"></sui-checkbox>
            </div>
          }
          <div class="post-type">
            <fa-icon [icon]="['fas', 'earth']"></fa-icon>
          </div>
          <!-- Take sentiment_id from the first element in post_sentiment_algorithm_list and use it as div class for sentiment
            sentiment_id 1 is neutral, 2 is positive, 3 is negative
            for text, use the "title" from the first element in post_sentiment_algorithm_list -->
          <div>
            <div
              [suiMenuTrigger]="sentimentMenu2"
              [suiMenuTriggerDisabled]="isShadow"
              class="sentiment {{
                sentimentClassMap[
                  post.post_sentiment_algorithm_list[0].sentiment_id
                ] ?? 'neutral'
              }}"
            >
              {{ post.post_sentiment_algorithm_list[0].title }}
            </div>
            <ng-template #sentimentMenu2>
              <sui-menu>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.NEGATIVE)"
                >
                  <fa-icon [icon]="['fas', 'face-frown']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.negative" | translate
                  }}</span>
                </button>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.NEUTRAL)"
                >
                  <fa-icon [icon]="['fas', 'face-meh']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.neutral" | translate
                  }}</span>
                </button>
                <button
                  sui-menu-item
                  (click)="setSentiment(NomSentiment.POSITIVE)"
                >
                  <fa-icon [icon]="['fas', 'smile']"></fa-icon>
                  <span>{{
                    "post-card.dropdown-item.positive" | translate
                  }}</span>
                </button>
              </sui-menu>
            </ng-template>
          </div>
          <div class="post-date">
            @switch (timeShown) {
              @case ("post_time_published_relative") {
                {{ post.publish_time.relative }}
              }
              @case ("post_time_published_absolute") {
                {{ post.publish_time.absolute | date: "dd.MM.yyyy HH:mm" }}
              }
              @case ("post_time_created_relative") {
                {{ post.created_time.relative }}
              }
              @case ("post_time_created_absolute") {
                {{ post.created_time.absolute | date: "dd.MM.yyyy HH:mm" }}
              }
            }
          </div>
          @if (user?.access_level_id >= UserAccessLevel.GLOBAL_ADMIN) {
            <div
              class="completeness-score"
              [class.low]="post.completeness_score <= 25"
              [class.medium]="
                post.completeness_score > 25 && post.completeness_score <= 75
              "
              [class.high]="post.completeness_score > 75"
            >
              <fa-icon [icon]="scoreIcon"></fa-icon>
              <span>{{ post.completeness_score }}</span>
            </div>
          }
          @if (
            post.has_synopsis &&
            userFacade.hasPermissionSync(
              AppComponents.POST_DETAILS_PANE_SYNOPSIS_EDITOR
            )
          ) {
            <div
              class="has-synopsis"
              [suiTooltip]="'post-card.tooltip.has-synopsis' | translate"
            >
              <fa-icon [icon]="['fas', 'clipboard-list']"></fa-icon>
            </div>
          }
          @if (post.has_transcription) {
            <div
              class="has-trancription"
              [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
            >
              <fa-icon [icon]="['fas', 'message']"></fa-icon>
            </div>
          }
          @if (hasScreenCapture) {
            <div
              class="has-screen-capture"
              [suiTooltip]="'post-card.tooltip.has-screen-capture' | translate"
            >
              <fa-icon [icon]="['fas', 'camera']"></fa-icon>
            </div>
          }
        </div>
        <div class="card-tools">
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.view-details' | translate"
              (click)="toggleDetails()"
              ><fa-icon [icon]="['fas', 'eye']"></fa-icon
            ></a>
          </div>
          @if (!isShadow) {
            <div class="card-tool">
              <a
                [suiTooltip]="'post-card.tooltip.edit-categories' | translate"
                (click)="editCategories()"
                ><fa-icon [icon]="['fas', 'tag']"></fa-icon
              ></a>
            </div>
          }
          @if (!isShadow) {
            <div class="card-tool">
              <sui-button
                size="sm"
                variant="ghost"
                [leadingIcon]="['fas', 'bars']"
                [trailingIcon]="['fas', 'caret-down']"
                [iconOnly]="true"
                ariaLabel="Algorithms"
                [expanded]="postAlgorithmsRef2.isOpen()"
                [suiMenuTrigger]="algorithmsMenu2"
                #postAlgorithmsRef2="suiMenu"
              ></sui-button>
              <ng-template #algorithmsMenu2>
                <sui-menu>
                  @for (item of algorithms; track item; let i = $index) {
                    @if (
                      i > 0 && algorithms[i].group !== algorithms[i - 1].group
                    ) {
                      <sui-menu-separator></sui-menu-separator>
                    }
                    <button sui-menu-item (click)="runAlgorithm(item)">
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item?.name }}</span>
                    </button>
                  }
                </sui-menu>
              </ng-template>
            </div>
          }
          @if (loadingAlgorithmPostIds?.includes(post.id)) {
            <div class="loading-post-algorithm">
              <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
            </div>
          }
          @if (appliedAlgorithmPostIds?.includes(post.id)) {
            <div
              class="applied-post-algorithm"
              [suiTooltip]="'post-card.tooltip.applied-algorithm' | translate"
            >
              <fa-icon [icon]="['fas', 'square-check']"></fa-icon>
            </div>
          }
          @if (removable && !disableTools && !isShadow) {
            <div class="card-tool remove-post">
              <a
                [suiTooltip]="'post-card.tooltip.remove-post' | translate"
                (click)="removeFromFeed()"
                ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
              ></a>
            </div>
          }
          @if (customRemovePost) {
            <div class="card-tool remove-post">
              <a
                [suiTooltip]="'post-card.tooltip.remove-post' | translate"
                (click)="customRemovePost(post); $event.stopPropagation()"
                ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
              ></a>
            </div>
          }
        </div>
      </div>
    }
    <div class="card-body" (click)="togglePostSelect()">
      @if (post.type === "social") {
        <div class="author">
          @if (post.author?.avatar_url) {
            <div class="avatar">
              @if (post.author.profile_url) {
                <a [href]="post.author.profile_url" target="_blank">
                  <img
                    [src]="post.author.avatar_url"
                    [appFallbackImage]="avatarFallback"
                    appLazyLoad
                    class="post-avatar"
                  />
                </a>
              }
              @if (!post.author.profile_url) {
                <img
                  [src]="post.author.avatar_url"
                  [appFallbackImage]="avatarFallback"
                  appLazyLoad
                  class="post-avatar"
                />
              }
            </div>
          }
          @if (post.author; as author) {
            <div class="author-info">
              <!-- Author Name -->
              @if (author.profile_url) {
                <a
                  [href]="author.profile_url"
                  target="_blank"
                  class="author-name"
                >
                  {{ author.name }}
                </a>
              }
              @if (!author.profile_url) {
                <span class="author-name">
                  {{ author.name }}
                </span>
              }
              <!-- Author Handle -->
              @if (author.username) {
                @if (author.profile_url) {
                  <a
                    [href]="author.profile_url"
                    target="_blank"
                    class="author-handle"
                  >
                    {{ "@" + author.username }}
                  </a>
                }
                @if (!author.profile_url) {
                  <span class="author-handle">
                    {{ "@" + author.username }}
                  </span>
                }
              }
            </div>
          }
        </div>
      }
      @if (post.thumbnail_big) {
        <a
          [href]="post.type === 'social' ? post.url : null"
          target="_blank"
          (click)="$event.stopPropagation()"
          class="thumbnail"
        >
          <img
            [src]="post.thumbnail_big"
            appFallbackImage
            [loadingImage]="loadingImage"
            (imageLoaded)="onImageLoaded()"
            appLazyLoad
            class="post-thumbnail"
          />
        </a>
      }
      <div class="card-content">
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
        @if (postPropertyConfig["content"]) {
          <a
            [attr.href]="post.type === 'social' ? post.url : null"
            target="_blank"
            (click)="$event.stopPropagation()"
            class="content"
            [innerHTML]="post.content"
          ></a>
        }
        @if (post.user_categories.length > 0) {
          <div class="user-categories">
            <span class="categories-title">{{
              "post-card.label.categories" | translate
            }}</span>
            @for (
              category of post.user_categories;
              track trackById($index, category)
            ) {
              <span class="user-category" (click)="editCategories()">
                <fa-icon [icon]="['fas', 'tag']"></fa-icon>
                {{ category.name }}</span
              >
            }
          </div>
        }
        @if (
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_EDIT_WORKFLOW
          ) && workflowStages?.length > 0
        ) {
          <div class="workflows">
            <span class="workflows-title">{{
              "post-card.label.workflows" | translate
            }}</span>
            @for (stage of workflowStages; track stage) {
              <div
                class="workflow-stage"
                [ngClass]="{
                  active: stage.is_current,
                  clickable: stage.enabled && !isShadow,
                }"
                (click)="
                  stage.enabled && !isShadow ? changeWorkflowStage(stage) : null
                "
              >
                @if (stage.is_previous) {
                  <fa-icon [icon]="['fas', 'backward-step']"></fa-icon>
                }
                {{ stage.name }}
                @if (stage.is_next) {
                  <fa-icon [icon]="['fas', 'forward-step']"></fa-icon>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if (post.attachments?.length > 0) {
      <div class="attachments">
        @for (
          attachment of post.attachments;
          track attachment;
          let i = $index
        ) {
          @if (!(attachment.is_thumbnail && attachment.type == "image")) {
            <div
              class="attachment

        {{ attachment.type }}"
            >
              @switch (attachment.type) {
                <!-- Video Attachment -->
                @case ("video") {
                  <app-video-player
                    [attachment]="attachment"
                    [postId]="post.id"
                    [attachmentId]="post.id + '-' + i"
                    [postTypeId]="post.post_type_id"
                    [contentProviderId]="post.content_provider.id"
                    [autoplay]="false"
                    [class.hide-transcriptions]="
                      !postToolsConfig['transcriptions']
                    "
                  >
                  </app-video-player>
                }
                <!-- Image Attachment -->
                @case ("image") {
                  <img
                    [src]="attachment.image_src"
                    appFallbackImage
                    [containerLevelsUp]="1"
                    (click)="openGallery()"
                  />
                  <!--
                      <a *ngIf="attachment.downloadable" [href]="attachment.href" download>Download</a>
                      -->
                }
                <!-- Article Attachment -->
                @case ("article") {
                  <div class="article-attachment">
                    <a
                      [href]="$safeNavigationMigration(attachment?.link)"
                      target="_blank"
                      >{{ attachment?.title }}</a
                    >
                    <span class="descritpion">
                      {{ attachment?.description }}
                    </span>
                  </div>
                }
              }
            </div>
          }
        }
      </div>
    }
    <div class="card-footer">
      <div class="source">
        <a [href]="post.source.url" target="_blank">
          <img
            [src]="post.source.icon_url"
            appFallbackImage
            [loadingImage]="loadingImage"
            appLazyLoad
          />
          {{ sourceTitle }}
        </a>
      </div>
      <div class="properties">
        @for (postProperty of postPropertyViewConfig; track postProperty) {
          @if (postProperty.value) {
            <div class="property">
              <div class="name">{{ postProperty.label }}</div>
              <div class="value">
                <fa-icon [icon]="postProperty.icon"></fa-icon>
                {{ postProperty.value }}
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
}

@if (viewMode == "compact") {
  <div
    class="post-card-compact item"
    [class.expanded]="compactExpanded"
    [class.sortable]="sortable"
    [style.background]="post.color_bg"
  >
    <div class="compact-row">
      @if (sortable) {
        <div
          class="drag-handle"
          cdkDragHandle
          [suiTooltip]="'post-card.tooltip.drag-to-reorder' | translate"
          [attr.aria-label]="'post-card.tooltip.drag-to-reorder' | translate"
        >
          <fa-icon [icon]="['fas', 'grip-vertical']"></fa-icon>
        </div>
      }
      <div class="tools switch-parent">
        <div
          class="parent"
          (click)="togglePostParentCard(post)"
          [suiTooltip]="
            'post-card.tooltip.select-this-post-as-post-parent' | translate
          "
        >
          P
        </div>
      </div>
      <div class="source">
        <div class="icon">
          <img [src]="post.source.icon_url" width="24" height="24" />
        </div>
        <div class="title">
          {{ sourceTitle }}
        </div>
      </div>
      @if (post.type === "social") {
        <div class="avatar">
          @if (post.author?.avatar_url) {
            <img
              [src]="$safeNavigationMigration(post.author?.avatar_url)"
              [appFallbackImage]="avatarFallback"
              appLazyLoad
              class="post-avatar"
            />
          }
        </div>
      }
      <div
        class="title"
        [innerHTML]="postCompactContent"
        [title]="postCompactContent"
      ></div>
      <button
        type="button"
        class="toggle-expand"
        (click)="compactExpanded = !compactExpanded"
        [suiTooltip]="
          (compactExpanded
            ? 'post-card.tooltip.collapse-post-content'
            : 'post-card.tooltip.expand-post-content'
          ) | translate
        "
      >
        <fa-icon
          [icon]="['fas', compactExpanded ? 'chevron-up' : 'chevron-down']"
        ></fa-icon>
      </button>
      <a
        class="open-post"
        [href]="post.url"
        target="_blank"
        rel="noopener"
        [suiTooltip]="'post-card.tooltip.open-post-in-new-tab' | translate"
      >
        <fa-icon [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
      </a>
      <div class="tools select">
        <div
          class="remove"
          (click)="togglePostSelect()"
          [suiTooltip]="
            'post-card.tooltip.remove-post-from-current-selected-list'
              | translate
          "
        >
          <fa-icon [icon]="['far', 'times-circle']"></fa-icon>
        </div>
      </div>
    </div>
    @if (compactExpanded) {
      <div class="expanded-content" [innerHTML]="post.content"></div>
    }
  </div>
}

<!-- Story mode view -->
@if (viewMode == "default" && isStoryMode) {
  <div
    class="post-card story-card"
    #card
    [ngClass]="{
      selected: post.selected,
      highlighted: highlighted,
    }"
    (click)="toggleDetails()"
  >
    <div class="card-header">
      <div class="card-info">
        @if (post.icon) {
          <div class="post-type">
            <fa-icon [icon]="post.icon"></fa-icon>
          </div>
        }
        @if (
          postToolsConfig["sentiment"] && post.post_sentiment_algorithm_list[0];
          as sentiment
        ) {
          <div
            class="sentiment {{
              sentimentClassMap[
                post.post_sentiment_algorithm_list[0]?.sentiment_id
              ] ?? 'neutral'
            }}"
          >
            {{ sentiment.title }}
          </div>
        }
        <div class="post-date">
          @switch (timeShown) {
            @case ("post_time_published_relative") {
              {{ post.publish_time.relative }}
            }
            @case ("post_time_published_absolute") {
              {{ post.publish_time.absolute | date: "dd.MM.yyyy HH:mm" }}
            }
            @case ("post_time_created_relative") {
              {{ post.created_time.relative }}
            }
            @case ("post_time_created_absolute") {
              {{ post.created_time.absolute | date: "dd.MM.yyyy HH:mm" }}
            }
          }
        </div>
      </div>
      <div class="card-tools">
        @if (!disableTools && postToolsConfig["view-details"]) {
          <div class="card-tool">
            <a
              [suiTooltip]="'post-card.tooltip.view-details' | translate"
              (click)="toggleDetails(); $event.stopPropagation()"
              ><fa-icon [icon]="['fas', 'eye']"></fa-icon
            ></a>
          </div>
        }
      </div>
    </div>
    <div class="story-card-body">
      @if (post.thumbnail) {
        <a
          class="thumbnail"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        >
          <img
            [src]="post.thumbnail"
            appFallbackImage
            [loadingImage]="loadingImage"
            [containerLevelsUp]="1"
            appLazyLoad
            class="post-thumbnail"
          />
        </a>
      }
      <div class="story-card-content">
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
        @if (postPropertyConfig["content"]) {
          <span class="content" [innerHTML]="post.content"></span>
        }
      </div>
    </div>
    @if (postPropertyViewConfig.length > 0) {
      <div class="story-card-footer">
        <div class="properties">
          @for (postProperty of postPropertyViewConfig; track postProperty) {
            <div class="property">
              <div class="name">{{ postProperty.label }}</div>
              <div class="value" [title]="postProperty.value">
                <fa-icon [icon]="postProperty.icon"></fa-icon>
                {{ postProperty.value | humanizeNumber: 1 }}
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
